module.exports = __webpack_public_path__ + "img/car-park.3693c955.jpg";